const iyfaaoPrice = {

    "PS1":35,
    "PS2":35,
    "PS3":35,
    "PS4":40,
    "PS5":45,

     "RS1":35,
    "RS2":35,
    "RS3":35,
    "RS4":40,
    "RS5":45,

     "BC1":35,
    "BC2":35,
    "BC3":35,
    "BC4":40,
    "BC5":45,

    "TT1":35,
    "TT2":35,
    "TT3":35,
    "TT4":40,
    "TT5":45,

    "DS1":35,
    "DS2":35,
    "DS3":35,
    "DS4":40,
    "DS5":45,

    "PW1":18,
    "PW2":18,
    "PW3":18,
    "PW4":28,
    "PW5":38,

    "SS1":18,
    "SS2":18,
    "SS3":18,
    "SS4":28,
    "SS5":38,

    
    "PV1":18,
    "PV2":18,
    "PV3":18,
    "PV4":28,
    "PV5":38,

    "TW1":18,
    "TW2":18,
    "TW3":18,
    "TW4":28,
    "TW5":38,

    "DP1":18,
    "DP2":18,
    "DP3":18,
    "DP4":28,
    "DP5":38,



}

export default iyfaaoPrice;